import Colors from '@/constants/Colors';
import MediaQueryBreakpoints from '@/constants/MediaQueryBreakpoints';
import styled from 'styled-components';

export const StyledSearchInputWithTypes = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  .input {
    width: 350px;

    input {
      font-size: 16px;
      &::placeholder {
        color: ${Colors.text}99;
      }
    }
  }

  .activity-type-search {
    margin-left: -6px;
    margin-right: -6px;
    cursor: pointer;

    .activity-type-button {
      display: flex;
      align-items: center;
      gap: 1px;
    }
  }

  @media only screen and (max-width: ${MediaQueryBreakpoints.xl}) {
    .input {
      width: 250px;
    }
  }

  @media only screen and (max-width: ${MediaQueryBreakpoints.lg}) {
    .input {
      width: 220px;
    }
  }

  @media only screen and (max-width: ${MediaQueryBreakpoints.md}) {
    width: 100%;

    .input {
      width: 100%;
    }
  }
`;

export const StyledPopover = styled.div`
  display: flex;
  flex-direction: column;

  .activity-type-icon {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 5px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background: ${Colors.primary}22;
      border-radius: 5px;
    }

    &.active {
      color: ${Colors.primary};
      font-weight: bold;
    }
  }
`;
